import { render, staticRenderFns } from "./InvestigadoresLineasModal.vue?vue&type=template&id=0138e210&"
import script from "./InvestigadoresLineasModal.vue?vue&type=script&lang=js&"
export * from "./InvestigadoresLineasModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports